export const MAX_LICENSES_COUNT = 1000000;
export const CLASSROOM_LOCAL_STORAGE_SORT_KEY = 'sortClassroomBMCs';
